import { useConversationalist } from '../../hooks'
import css from './ChatHeader.module.scss'
import { SyncButton, useSyncAllowed } from './SyncButton'

export function ChatHeader() {
	const conversationalist = useConversationalist()
	const hasSync = useSyncAllowed()
	return (
		conversationalist && (
			<header className={css.header}>
				<a
					className={css.link}
					href={`https://www.linkedin.com/in/${conversationalist.entityId}`}
					rel='noopener noreferrer'
					target='_blank'
				>
					<h2 className={css.person}>{conversationalist.fullName}</h2>
				</a>
				<p className={css.lead}>{conversationalist.occupation}</p>
				{hasSync && <SyncButton />}
			</header>
		)
	)
}
